var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.74219 13.9365V14.9934C2.74219 15.4771 3.13629 15.8533 3.60204 15.8533H4.69477L4.78434 16.122C4.96347 16.6415 5.42923 16.9997 5.96663 16.9997C6.50404 16.9997 6.9698 16.6415 7.14893 16.122L7.2385 15.8533H8.33123C8.8149 15.8533 9.19108 15.4592 9.19108 14.9934V13.9365H2.74219Z",
    fill: "#0078E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33079 10.6765C2.58158 10.8735 2.7428 11.2139 2.7428 11.5901V12.6649H9.19169V11.5543C9.19169 11.196 9.335 10.8736 9.58579 10.6944C11.0726 9.54794 11.9325 7.82824 11.9325 5.96523C11.9325 4.13804 11.1084 2.43625 9.67536 1.28978C8.60055 0.44784 7.32868 0 5.96725 0C5.48358 0 5.01783 0.0537408 4.53416 0.161222C2.42036 0.662803 0.718565 2.34668 0.181158 4.44257C-0.392077 6.82508 0.414035 9.20759 2.33079 10.6765ZM5.96725 10.0495C5.50149 10.0495 5.12531 9.67334 5.12531 9.20759C5.12531 8.74183 5.50149 8.36565 5.96725 8.36565C6.433 8.36565 6.80919 8.74183 6.80919 9.20759C6.80919 9.67334 6.433 10.0495 5.96725 10.0495ZM5.87768 2.91992C6.36135 2.86617 6.79127 3.22445 6.84501 3.72603C6.84501 3.77977 6.84501 3.83351 6.84501 3.88725L6.5584 7.04004C6.52257 7.36249 6.23595 7.59536 5.91351 7.57745C5.62689 7.55954 5.41193 7.32666 5.3761 7.04004L5.08948 3.88725C5.03574 3.40358 5.39401 2.97366 5.87768 2.91992Z",
    fill: "#0078E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.f5f28d38b72b9292f7724a9d0776bf23.svg";
export { ForwardRef as ReactComponent };